export const SERVICE_LIMIT_SERVICE_USAGE_THRESHOLD_ZERO = {
  serviceDeliveredNum: 0,
};

export const SERVICE_LIMIT_SERVICE_USAGE_THRESHOLD_HIGH = {
  serviceDeliveredNum: 25,
};
